export enum CommonCharacters {
  HIDDEN_PASSWORD = '',
}
